export default function errorToast({
  toast,
  description,
  duration = 1500
}: {
  toast: any
  description: string
  duration?: number
}) {
  return toast.add({
    title: description,
    duration,
    icon: 'i-heroicons-exclamation-triangle',
    ui: {
      root: 'bg-[#303338]',
      icon: 'bg-red-400'
    },
    close: {
      class: 'text-white/80 hover:text-white'
    },
    progress: {
      color: 'error',
      ui: {
        base: 'bg-[#303338]'
      }
    }
  })
}
